
export default {
  name: 'ListActions',
  props: {
    showDetail: {
      type: Boolean,
      default: () => false
    },
    showDetailTitle: {
      type: String,
      default: 'Lihat Detail'
    },
  }
}
